module.exports = __webpack_public_path__ + "img/jiuzhang-back-one.88fd51cc.jpg";